module.exports = __webpack_public_path__ + "img/lock.3ad34a20.svg";